import CookieService from "../../../common/ts/services/CookieService";

export const CONSENT_COOKIE_NAME: string = "cookieBannerDesktop";

const DAYS_TO_EXPIRE = 30;

export class DisclaimerCookie {

    private readonly cookieService: CookieService = new CookieService();

    constructor() {
        const banner = document.getElementById("cookie-disclaimer");
        if (banner) {
            this.setExpirableCookie('true');
            (document.getElementById("accept-cookie-disclaimer-button") as HTMLElement)
                .addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.hideDisclaimerCookieBanner();
                });
            (document.getElementById("deny-cookie-disclaimer-button") as HTMLElement)
                .addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.setExpirableCookie('false');
                    location.reload();
                });
        }
    }

    private setExpirableCookie(cookieValue: string) {
        this.cookieService.setExpirableCookie(
            CONSENT_COOKIE_NAME,
            cookieValue,
            DAYS_TO_EXPIRE
        );
    }

    private hideDisclaimerCookieBanner() {
        const disclaimerCookieContainer = document.getElementById("cookie-disclaimer") as HTMLElement;
        disclaimerCookieContainer.style.display = "none";
    }
}
